import { Psychology } from '@mui/icons-material';
import {
  AppBar,
  Box,
  Container,
  Stack,
  Toolbar,
  Typography
} from '@mui/material';
import { brandVars as brand } from '@/theme/theme';
import Link from 'next/link';
import type { FunctionComponent, ReactNode } from 'react';

type AppHeaderProps = {
  children?: ReactNode;
  logoHref?: string;
};

export const AppHeader: FunctionComponent<AppHeaderProps> = ({
  children,
  logoHref = '/dashboard'
}) => {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'grey.200'
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1 }}>
          <Stack
            component={Link}
            href={logoHref}
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1.5,
              textDecoration: 'none',
              mr: 4
            }}
          >
            <Box
              sx={{
                background: brand.gradients.logo,
                p: 1,
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Psychology sx={{ color: 'white', fontSize: 24 }} />
            </Box>
            <Typography
              variant="h6"
              sx={{ color: 'text.primary', fontWeight: 700 }}
            >
              FraudFront
            </Typography>
          </Stack>

          {children}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
